export default "__VITE_ASSET__B0u48yJd__"